<template>
    <div class="flex-col">
        <vnavbar title="评分列表" class="backbar" left-text="返回" left-arrow @click-left="back" />
        <div class="header" v-if="surgeryInfo">
            <div class="patient">
                <div class="name">{{surgeryInfo && surgeryInfo.patient_name}}</div>
                <div class="bed">{{surgeryInfo && surgeryInfo.sex||'--'}}/{{surgeryInfo && surgeryInfo.age||'--'}}/{{surgeryInfo.bed_no||'--'}}</div>
            </div>
            <div>
            <div class="more"><div class="moredevice">{{surgeryInfo.surgeries}}</div><div @click="isShowMore=!isShowMore">查看更多<span><i :class="isShowMore?'el-icon-arrow-up':'el-icon-arrow-down'"></i></span></div></div>
            <div v-if="isShowMore" class="surgery">
                <div>台次:{{surgeryInfo.scheduled_sequence}}</div>
                <div>手术间:{{surgeryInfo.dic_operating_room}}</div>
                <div>科室:{{surgeryInfo.dic_section}}</div>
                <div>术前诊断:{{surgeryInfo.plan_diseases}}</div>
                <div>手术医生:{{surgeryInfo.surgeon}}</div>
                <div class="time">手术计划开始时间:{{surgeryInfo.plan_time && this.$moment(surgeryInfo.plan_time).format(`YYYY-MM-DD HH:mm:ss`)}}</div>
            </div>
            </div>
        </div>
        <div v-if="scoreList && scoreList.length>0" class="scrollContent">
            <vpullrefresh v-model="refreshing" @refresh="onRefresh">
                <vlist v-model="loading" :finished="finished" finished-text="" @load="onLoad">
                    <div class="content flex-col" v-if="scoreList && scoreList.length>0" :style="{'height':`${ this.screenHeight - 200}px`}">
                        <div class="middle flex-row justify-between" style="height: 50px;align-items: center; background-color: ghostwhite;border: 1px solid #dcdfe6;"
                            v-for="(scoreitem, index) in scoreList" @click="showScore(scoreitem.id)" :key="index">
                            <div class="flex-col" style="padding-left: 20px;">
                                {{scoreitem.name}}
                            </div>
                            <div class="flex-col" style="padding-right: 10px; font-weight: 500;">
                                <span style="width: 50px;background-color: darkseagreen;">{{scoreitem.score || 0}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <vempty description="暂无数据" class="empty" />
                    </div>
                </vlist>
            </vpullrefresh>
        </div>
    </div>
</template>

<script>
import { NavBar as vnavbar, Empty, Button as vbutton, Dialog, Field as vfield, PullRefresh as vpullrefresh, List as vlist, Icon as vicon, Tag as vtag } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
export default {
    name: `ScoreInfo`,
    components: { vnavbar, Empty, vbutton, [Dialog.Component.name]: Dialog.Component, vfield, vlist, vicon, vtag, vpullrefresh },
    data() {
        return {
            surgeryId: parseInt(this.$route.query.surgeryId),
            surgeryInfo: this.$route.params.surgeryInfo,
            isShowMore: false,
            loading: false,
            finished: false,
            refreshing: false,
            scoreList: [
                {
                    id: 1,
                    name: `压疮危险因素Braden评分`
                },
                {
                    id: 2,
                    name: `创伤TS评分`
                },
                {
                    id: 3,
                    name: `ASA病情分级`
                }
            ]
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `sysuser/workers`, `screenHeight`, `operation_ward_auth`, `active_hospital_ward`])
    },
    created() {
        // window.localStorage.setItem(`allscoreList`, null)
        this.onLoad()
    },
    mounted() {},
    methods: {
        showScore(id) {
            this.$router.push({ name: `ScoreDetail`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, scoreId: id } }).catch(err => err)
        },
        back() {
            this.$router.push({ path: `/t_transferList` }).catch(err => err)
        },
        onLoad() {
            let that = this
            this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
                let allscoreList = JSON.parse(localStorage.getItem(`allscoreList`)) || []
                let scoreInfo = allscoreList && _.filter(allscoreList, { surgeryId: that.surgeryId })
                that.scoreList = _.map(that.scoreList, (d, index) => {
                    var item = scoreInfo && _.find(scoreInfo, { scoreId: d.id })
                    d.score = item && item.result
                    return d
                })
            })
        },
        onRefresh() {
            let that = this
            that.refreshing = false
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            if (newUrl.path == `/t_scoreInfo`) {
                this.surgeryId = parseInt(this.$route.query.surgeryId)
                this.onLoad()
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.backbar{
    background-color: #04A891;
    border:unset !important;
    /deep/ .van-icon{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__text{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__title{
        color:#ffffff !important;
    }
}
.van-hairline--bottom::after{
    border-bottom-width:0px !important;
}
.header {
    color:#ffffff !important;
    background: #04A891 !important;
    font-size: 14px;
    text-align: left;
    .patient {
        line-height: 23px;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        height: 46px;
        .name{
            padding:0 20px;
            font-size: 17px;
        }
    }
    .surgery {
        border-top: 1px dashed #ffffff;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-wrap: wrap;
        div {
            width: 50%;
            height:30px;
            line-height:30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            padding: 0 16px;
        }
        .time{
            flex-basis:100% !important;
        }
    }
    .more{
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        justify-content: space-between;
        margin: 0 16px;
        padding-bottom: 10px;
        .moredevice{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            max-width: 80%;
        }
        }
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width:100%;
    .btnTrans {
        flex:1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 30px;
        color: #ffffff;
    }
}

.line{
    margin:0px 24px;
    width:1px;
    height:130px;
    background:#EBEBEB;
}
.scrollContent{
    overflow-y: auto;
    overflow-x: hidden;
}
.content{
    display:flex;
    font-size:20px;
    .panel{
        position: relative;
        width: 100%;
        padding: 0 16px;
        text-align: left;
        .monthday{
            position: absolute;
            left:-40px;
            top:0px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .date{
            position: absolute;
            left:-40px;
            top:8px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .step{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: start;
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
        }
        .steprowone{
            flex-basis: 70%;
            font-weight: 500;
            font-size: 20px;
            color: var(--primary-color, #009688);
            line-height: 36px;
            height: 36px;
            text-align: left;
            font-style: normal;
            overflow-wrap: break-word;
            white-space: nowrap;
            margin-top: 1px;
        }
        .phone{
            background-color: #E0F2EE;
            border-radius: 50%;
            height: 24px;
            width: 24px;
            line-height: 24px;
            text-align: center;
        }
        .steprowtwo{
            flex-basis: 100%;
            margin-top: 5px;
        }
        .remark{
            flex-basis: 90%;
            padding: 5px 10px 10px 0px;
            background-color: rgba(245, 245, 245, 1);
            border-radius: 2px;
        }
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/ScoreInfo.vue